import {IState} from '../../../typescript/redux/interfaces'

const getToken = (state: IState) => state.authorization.token;
const getNumber = (state:IState) => state.authorization.number;
const getName = (state: IState) => state.authorization.name;
const getLastName = (state: IState) => state.authorization.lastName;
const getCountry = (state: IState) => state.authorization.country;
const getAvatarUrl = (state: IState) => state.authorization.avatarUrl;
const getId = (state: IState) => state.authorization._id;
const getSort = (state: IState) => state.authorization.sort;
const getNightMode = (state: IState) => state.authorization.nightMode;
const getSilentMode = (state: IState) => state.authorization.silentMode;
const getAuthorizationState= (state:IState) => state.authorization;

export { getToken,getNumber,getName,getLastName,getCountry,getAvatarUrl,getId,getSort,getNightMode,getSilentMode,getAuthorizationState };
